import React, { useEffect, useState } from "react";
import LoginForm from "../../loginPage/login/loginForm";
import Footer from "../footer";
import Intro from "../intro";
import "../login.css";
import { useLocation, Link, useNavigate } from "react-router-dom";
import {
  useLogoutMutation,
  useOtpsentMutation,
  usePasswordverificationMutation,
} from "../../../services/loginservices";
import { useDispatch } from "react-redux";
import { createAlert } from "../../../features/alert/alerts";
import { ALERT_TYPE_SUCCESS, LOGIN_USER_TYPE_SERVICE_VOTER,LOGIN_USER_TYPE_ECI_OFFICIAL, USERTYPE, BASE_URLS, PLATFORM_TYPE } from "../../../constants/constants";
import { ALERT_TYPE_ERROR } from "../../../constants/constants";
import CustomModal from "../../../library/components/Modal/modal";
import { parseJwt } from "../../utilities/utils";
import Button from '../../../library/components/Button'
import SelectField from '../../../library/components/Select'
import { Validators } from '../../../library/utilities/Validator'
import PasswordField from '../../../library/components/Password'
import InputField from '../../../library/components/InputField'
import { useLazyUpdateLoginStatusForCSQuery } from "../../../services/announceElection";
import { styles } from "./members/member";
import MembersDetails from "./members/memberDetails";
import { setCookie } from "../../utilities/cookieUtils";
import axios from "axios";

function VerifyLogin() {
  let navigate = useNavigate();
  const [passwordverify, datap] = usePasswordverificationMutation();
  const [logoutApi] = useLogoutMutation()
  const [otpsent] = useOtpsentMutation();
  const location =useLocation()
  const [exceedError, setExceedError] = useState(false);
  // const[userType,setUserType]=useState(location?.state?.key ||"ECI Official")
  const [resetPassword, setresetPassword] = useState(false);
  const [Error, setError] = useState({});
  const [roless, setRoles] = useState();
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const [loginObj, setLoginObj] = useState({
    userId: "",
    password: "",
    captcha: "",
    role: "",
  });
  const[roleForCS,setRoleForCS] = useState("")
  const [ updateLogin,datal] = useLazyUpdateLoginStatusForCSQuery()

  const handleChange = (key, event) => {
    setLoginObj({ ...loginObj, [key]: event })
  }
  const getError = (key, value) => {
    let error = { ...Error }
    if (value && value.message) {
      setError({ ...Error, [key]: value.message })
    } else {
      delete error[key]
      setError(error)
    }
  }
  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Reject",
      })
    );
  };
  useEffect(()=>{
    
    if(!location?.state?.userId){
  navigate("/login",{state:{replace:true}})
  return
     }
    setLoginObj((prevState)=>({
      ...prevState,
      userId:location?.state?.userId,
     
    }))

  },[])

  const handlesubmit = async (e, data) => {
    e.preventDefault();
    let error = {};
    // if (!loginObj.userType || loginObj.userType === "") {
    //   error["userType"] = "This field is required";
    // }
    // if (location.state.userId || location.state.userId === "") {
    //   error["userId"] = "This field is required";
    // }
    // else if (loginObj.userId != "" && !(new RegExp(/^[\sA-Za-z\-\.,'/()&]{0,250}$/).test(loginObj.userId))){
    //   error["userId"] = "Please enter valid userId";
    // }
    if (!loginObj.password || loginObj.password === "") {
      error["password"] = "This field is required";
    } 
    if (Object.keys(error).length) {
      setError(error);
      return;
    }
    var data = {
      applicationName: USERTYPE.ERONET,
      // password: "a",
      roleCode: "*",
      password: loginObj.password,
      // username: "9123456781"
      username: loginObj.userId.trim(),
    }

 

  
    passwordverify(data);

  // var eciData = {
  //   applicationName: "back_office",
  //   roleCode: "*",
  //   username: loginObj.userId.trim(),
  // };
  // var serviceData = {
  //   applicationName: "etpbs",
  //   roleCode: loginObj.userType,
  //   username: loginObj.userId.trim(),
  // };
  // if(loginObj.userType && (loginObj.userType=="cs"||loginObj.userType=="ro"||loginObj.userType=="nodl"||loginObj.userType=="recd"||loginObj.userType=="unit")){
  //   otpsent(serviceData);
  // }else{
  //   otpsent(eciData);
  //  }
  
  // navigate(`/otp/${loginObj.userId}`,{state:loginObj.userType});
  };
// console.log(location.state?.app)

  async function logMeoutConfirm (access_token,refresh_token,rtkn_bnd,atkn_bnd) {
     try{
       setCookie("XUSRLGLK",'true')
      let response = await axios.post(
        BASE_URLS.LOGIN_BASE_URL + "api/v1/authn-sso/logout",
        {
          userName : parseJwt(access_token).preferred_username, 
          id : parseJwt(access_token).session_state
        },
        {
          withCredentials:true,
          headers: {
            'Content-Type': 'application/json',
            'applicationName':USERTYPE.ETPBMS,          
            'Authorization': 'Bearer ' + access_token,
            // 'userName':parseJwt(localStorage?.access_token)?.preferred_username,            
            'refreshToken': refresh_token,      
            "atkn_bnd": atkn_bnd,
            "rtkn_bnd": rtkn_bnd,
            "channelidobo": "ETPBMS", 
            "PLATFORM-TYPE":PLATFORM_TYPE
          },
        }
      );
      if (response.status == 200) {
       localStorage.clear()
        navigate('/login')
      } else {
       localStorage.clear()
        navigate('/login')
      }
     }
     catch(error){
     localStorage.clear()
      navigate('/login')
     }
    };

  useEffect(() => {
    if (datap.isSuccess) {
      let userRoles = parseJwt(datap.data?.access_token).realm_access.roles;
      if (datap.data?.firstTimeLogin == "Y") {
        
      if(userRoles.includes("CS")||userRoles.includes("cs")){
          localStorage.setItem("first_token", datap.data?.access_token);
        localStorage.setItem(
          "rtkn_bnd",
          datap.data?.rtkn_bnd
        );
        localStorage.setItem(
          "atkn_bnd",
          datap.data?.atkn_bnd
        );
       
        for (let i = 0; i < userRoles.length; i++) {
          if (
            (
              userRoles[i]==="nodal" ||
              userRoles[i]=== "unit" ||
              userRoles[i]=== "record" ||
              userRoles[i]=== "ro" ||
              userRoles[i]=== "cs"
            )
          )
          localStorage.setItem(
            "userrole",
            userRoles[i]
          );
        }
        navigate("/requestotp", { state: { userId:loginObj.userId} });
      }else{
        onReject("Change Your Password first at ECINet")
        logMeoutConfirm(datap.data?.access_token,datap.data?.refresh_token, datap.data?.rtkn_bnd,datap.data?.atkn_bnd)
      }
        // , { state: { show: true, number: data } }
      } 
      
      else if (datap.data?.firstTimeLogin == "M") {
        localStorage.setItem("firstLogin","M" );
        localStorage.setItem("first_token", datap.data?.access_token);
        localStorage.setItem(
          "first_role",
          parseJwt(datap.data?.access_token).realm_access.roles[0]
        );
        localStorage.setItem(
          "rtkn_bnd",
          datap.data?.rtkn_bnd
        );
        localStorage.setItem(
          "atkn_bnd",
          datap.data?.atkn_bnd
        );
        navigate("/requestotp", { state: { userId:loginObj.userId} });
        // , { state: { show: true, number: data } }
      } 
      else {
       
        localStorage.setItem("refreshToken", datap.data?.refresh_token);
        localStorage.setItem("expiry", datap.data?.expires_in);
        localStorage.setItem("refreshExpiry", datap.data?.refresh_expires_in);
        // localStorage.setItem(
        //   "userrole",
        //   parseJwt(datap.data?.access_token).realm_access.roles[0]
        // );
        localStorage.setItem(
          "roles",
          parseJwt(datap.data?.access_token).realm_access.roles
        );
        localStorage.setItem(
          "rtkn_bnd",
          datap.data?.rtkn_bnd
        );
        localStorage.setItem(
          "atkn_bnd",
          datap.data?.atkn_bnd
        );
        var roles = [{ value: "", label: "Select Role" }];
        var role = userRoles;
        for (let i = 0; i < userRoles.length; i++) {
          if (
            !(
              role[i].includes("default") ||
              role[i].includes("offline") ||
              role[i].includes("admn") ||
              role[i].includes("authorization")
            )
          )
            roles.push({ value: role[i], label: role[i] });
        }
        setRoles(roles);

        if (roles.length > 2) {
          setShow(true);
          // window.location.href = "/" + stateValue.role
        } else {
          var elseroles = [];
          for (let i = 0; i < userRoles.length; i++) {
            if (
              !(
                role[i].includes("default") ||
                role[i].includes("offline") ||
                role[i].includes("admn") ||
                role[i].includes("authorization")
              )
            )
              elseroles.push(role[i]);
          }
         
          // if((elseroles[0]).toLowerCase()=="cs"){
          //   setRoleForCS((elseroles[0].toLowerCase()))
          
          // }else{
          //   localStorage.setItem("access_token", datap.data?.access_token);
          //   localStorage.userrole = elseroles[0];
          //   window.location.href = "/" + elseroles[0]+"/"+"dashboard";
          // }
          localStorage.setItem("access_token", datap.data?.access_token);
          localStorage.userrole = elseroles[0];
          updateLogin(datap.data?.access_token).unwrap().then((res)=>{ 
           navigate("/" + elseroles[0]+"/"+"dashboard")}).catch((err)=>{
             navigate("/" + elseroles[0]+"/"+"dashboard")
            })
        }
      }
    }
  }, [datap.isSuccess]);

  // useEffect(()=>{
  //   if(roleForCS=="cs"){
  //     localStorage.setItem("access_token",datap.data?.access_token)
  //     updateLogin(datap.data?.access_token).unwrap().then((res)=>{localStorage.userrole = roleForCS;
  //       window.location.href = "/" + roleForCS+"/"+"dashboard";}).catch((err)=>{
  //         localStorage.userrole = roleForCS;
  //     window.location.href = "/" + roleForCS+"/"+"dashboard";
  //       })
  //   }
  // },[roleForCS,setRoleForCS])


  useEffect(() => {

    if (datap.isError) {

      if (datap.error.data && datap.error.data.cause && datap.error.data.cause !== null) {
        if (datap.error.data && datap.error.data.cause && datap.error.data.cause.disabled === false) {
          onReject(
            `Incorrect Attempts : ` +
              datap.error.data.cause.numFailures +
              `. You will be locked after ${datap.error.data.cause.allowedIncorrectAttempts} Incorrect attempts`
          );
        } else {
          onReject(
            // "Incorrect Attempts : " +
            //   datap.error.data.cause.numFailures +
              `\n You are locked for ${datap.error.data.cause.waitTimeAfterLock / 60} minutes. `
          );
        }
      }

      // var data1 = {
      //   applicationName: "back_office",
      //   roleCode: "*",
      //   // username: "9123456781"
      //   username:loginObj.userId
      // }
      // otpsent(data1)
      // navigate(`/otp/${loginObj.userId}`);
    }
  }, [datap.isError]);

   function shouldShowLink(userId) {
  const regex = new RegExp(`^(A0|CS)\\w*$`, "i");
 
  return regex.test(userId);
}

  return (
  <div style={styles.main}>
               <div style={styles.row}>
       
                 {/* Left Div - Commissioners */}
                 <MembersDetails></MembersDetails>
                   <div style={styles.boxLogin}>
             <div
               className="form_login"
               // onShow={localStorage.clear()}
             >
          <form onSubmit={handlesubmit} className="form_align">
            <div className="form_login">
              <div className="mr-2">
                 <div className="row p-2">
                  <div className="col-sm-12 heading_login text-center">
          <h4 className="heading_login_title">Login</h4>
          <p className="heading_login_subtitle" style={{lineHeight:"normal"}}>Enter Details</p>
           <p className="heading_login_subtitle" style={{lineHeight:"normal"}}>To Get Sign In To Account
</p>
                    {/* <p>Do not have an account? <Link to="/signUp">Sign-Up</Link></p> */}
                  </div>
                </div>

                <div className="row p-2">
                <InputField
          label="Username"
          maxLength="100"
          name="userId"
          required={true}
          placeholder="Enter user id"
          inputClass="col-md-12 forminputLogin"
          iconclass="fas fa-envelope"
          labelClass="col-md-12 d-none"
          disabled={true}
          value={loginObj.userId}
          onChange={(val) => handleChange('userId', val)}
          validators={[
            // {
            //   check: Validators.textinput,
            //   message: "Please enter valid userId.",
            // },
            {
              check: Validators.required,
              message: 'This field is required',
            },
          ]}
          getError={(val) => getError('userId', val)}
          Error={Error}
        />
                </div>
                <div className="row p-2 pb-0">
                  <PasswordField
                    label="Password"
                    name="password"
                    onPaste={true}
                    onDrop={true}
                    onCopy={true}
                    onCut={true}
                    autoComplete={"off"}
                    placeholder="Password"
                    required={true}
                    iconclass="fas fa-eye"
                    inputClass="col-md-12 forminputLogin"
                    labelClass="col-md-12 d-none"
                    value={loginObj.password}
                    onChange={(val) => handleChange("password", val)}
                    validators={[
                      // {
                      //   check: Validators.passwordupper,
                      //   message: "Atleast one uppercase required",
                      // },
                      // {
                      //   check: Validators.passworddigit,
                      //   message: "Atleast one digit required",
                      // },
                      // {
                      //   check: Validators.passwordspecial,
                      //   message: "Atleast one valid special character(@ , _ - ! # .) required",
                      // },
                      // {
                      //   check: Validators.passwordmin,
                      //   message: "Atleast eight characters required",
                      // },
                      {
                        check: Validators.required,
                        message: "This field is required",
                      },
                    ]}
                    getError={(val) => getError("password", val)}
                    Error={Error}
                  />
                </div>
                {shouldShowLink(location.state?.userId)&&<div className="row px-2 pb-3">
                  <div className="col-sm-12 forgot-password-link">
                    <Link to="/forgotpassword" className="text-primary">
                      Forgot Password?
                    </Link>
                  </div>
                </div>}
                <Button
                  btnClass="btn-block submit my-2 btnpurple"
                  value={`Login`}
                  type="submit"
                  // disabled={buttoneDis}
                />
                {/* {exceedError && (
          <div className="displayMessage">
            You cannot login. You have exceeded the maximum limit. Please try
            again tomorrow.
          </div>
        )}
        {resetPassword && (
          <div className="displayMessage">
            Time to reset your password, by clicking the Forgot Password button
            below.
          </div>
        )} */}
                <CustomModal
                  modalTitle=""
                  children={
                    <div className="pl-3 pt-2">
                      <SelectField
                        label="Select Role"
                        required={true}
                        name="role"
                        options={roless}
                        // options={dropdownvaluefilter(formtypefilter,"value")}
                        labelClass="col-md-12 pr-0 pt-2 processing-label"
                        inputClass="col-md-12"
                        value={loginObj.role}
                        handleChange={(val) => handleChange("role", val)}
                      />
                    </div>
                  }
                  show={show}
                  size="30%"
                  modalFooter={
                    <Button
                      btnClass="px-4 btn-blue mb-4 float-right"
                      value={<>Submit &nbsp;</>}
                      type="submit"
                      onClick={() => {
                        setShow(false);
                               
                        updateLogin(datap.data?.access_token).unwrap().then((res)=>{
                          localStorage.userrole = loginObj.role;
                          localStorage.setItem("access_token",datap.data?.access_token)
                            //  loginAuthContext(datap.data?.access_token,loginObj.role)
                        //  navigate("/" + loginObj.role+"/"+"dashboard")
                          window.location.href = "/" + loginObj.role+"/"+"dashboard";
                        }).catch((err)=>{
                          localStorage.userrole = loginObj.role;
                          localStorage.setItem("access_token",datap.data?.access_token)
                          // loginAuthContext(datap.data?.access_token,loginObj.role)
                      //  navigate("/" + loginObj.role+"/"+"dashboard")
                        window.location.href = "/" + loginObj.role+"/"+"dashboard";
                          })
                        // localStorage.userrole = loginObj.role;
                        // window.location.href = "/" + loginObj.role+"/"+"dashboard";
                      }}
                    />
                  }
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    </div>
  );
}

export default VerifyLogin;
